<template>
  <div
    class="relative flex items-center justify-center"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-full h-full absolute inset-0"
      :viewBox="`0 0 ${size} ${size}`"
    >
      <g :transform="`matrix(1 0 0 1 ${center} ${center}) scale(${logoScale})`">
        <g transform="matrix(1 0 0 1 29.69 -1)">
          <path
            :style="{
              stroke: 'none',
              'stroke-width': 1,
              'stroke-dasharray': 'none',
              'stroke-linecap': 'butt',
              'stroke-dashoffset': 0,
              'stroke-linejoin': 'miter',
              'stroke-miterlimit': 4,
              fill: loaderColor,
              'fill-rule': 'evenodd',
              opacity: 1,
            }"
            transform=" translate(-16.42, -20)"
            d="M 32.849998474121094 0 C 32.849998474121094 0 32.849998474121094 32.86000061035156 32.849998474121094 32.86000061035156 C 32.849998474121094 40.369998931884766 22.700000762939453 42.779998779296875 19.290000915527344 36.08000183105469 C 19.290000915527344 36.08000183105469 8.819999694824219 14.3100004196167 8.819999694824219 14.3100004196167 C 8.819999694824219 14.3100004196167 8.819999694824219 40 8.819999694824219 40 C 8.819999694824219 40 0 40 0 40 C 0 40 0 7.420000076293945 0 7.420000076293945 C 0 -0.09000000357627869 10.149999618530273 -2.5 13.5600004196167 4.199999809265137 C 13.5600004196167 4.199999809265137 24.030000686645508 24.770000457763672 24.030000686645508 24.770000457763672 C 24.030000686645508 24.770000457763672 24.030000686645508 0 24.030000686645508 0 C 24.030000686645508 0 32.849998474121094 0 32.849998474121094 0 C 32.849998474121094 0 32.849998474121094 0 32.849998474121094 0 z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -19.34 -1.11)">
          <path
            :style="{
              stroke: 'none',
              'stroke-width': 1,
              'stroke-dasharray': 'none',
              'stroke-linecap': 'butt',
              'stroke-dashoffset': 0,
              'stroke-linejoin': 'miter',
              'stroke-miterlimit': 4,
              fill: loaderColor,
              'fill-rule': 'nonzero',
              opacity: 1,
            }"
            transform=" translate(-28.66, -19.89)"
            d="M 0 0 C 0 0 0 23.450000762939453 0 23.450000762939453 C 0 32.459999084472656 7.480000019073486 39.779998779296875 16.68000030517578 39.779998779296875 C 21.469999313354492 39.779998779296875 25.790000915527344 37.79999923706055 28.829999923706055 34.630001068115234 C 31.829999923706055 37.79999923706055 36.09000015258789 39.779998779296875 40.849998474121094 39.779998779296875 C 49.939998626708984 39.779998779296875 57.310001373291016 32.459999084472656 57.310001373291016 23.450000762939453 C 57.310001373291016 23.450000762939453 57.310001373291016 0 57.310001373291016 0 C 57.310001373291016 0 48.47999954223633 0 48.47999954223633 0 C 48.47999954223633 0 48.47999954223633 23.450000762939453 48.47999954223633 23.450000762939453 C 48.47999954223633 27.610000610351562 45.08000183105469 31.010000228881836 40.849998474121094 31.010000228881836 C 37.04999923706055 31.010000228881836 33.90999984741211 28.270000457763672 33.310001373291016 24.690000534057617 C 33.34000015258789 24.280000686645508 33.36000061035156 23.8700008392334 33.36000061035156 23.450000762939453 C 33.36000061035156 23.450000762939453 33.36000061035156 0 33.36000061035156 0 C 33.36000061035156 0 24.3799991607666 0 24.3799991607666 0 C 24.3799991607666 0 24.3799991607666 23.450000762939453 24.3799991607666 23.450000762939453 C 24.3799991607666 23.649999618530273 24.3799991607666 23.84000015258789 24.389999389648438 24.040000915527344 C 24.079999923706055 27.93000030517578 20.760000228881836 31.010000228881836 16.68000030517578 31.010000228881836 C 12.399999618530273 31.010000228881836 8.949999809265137 27.610000610351562 8.949999809265137 23.450000762939453 C 8.949999809265137 23.450000762939453 8.949999809265137 0 8.949999809265137 0 C 8.949999809265137 0 0 0 0 0 C 0 0 0 0 0 0 z"
            stroke-linecap="round"
          />
        </g>
      </g>
      <circle
        v-for="(dot, index) in dots"
        :key="index"
        :cx="dot.x"
        :cy="dot.y"
        :r="dotRadius"
        :fill="loaderColor"
        :style="{
          animationDelay: `${dot.appearanceDelay}s`,
          animationDuration: `${animationSpeed}s`,
        }"
        class="dot"
      />
      <circle
        :cx="dots[0].x"
        :cy="dots[0].y"
        :r="dotRadius"
        :fill="loaderColor"
        :style="{
          animationDelay: `${props.animationSpeed / 2}s`,
          animationDuration: `${animationSpeed}s`,
        }"
        class="dot"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue'

const props = defineProps({
  size: {
    type: Number,
    default: 100,
  },
  loaderColor: {
    type: String,
    default: 'rgb(0, 122, 255)',
  },
  animationSpeed: {
    type: Number,
    default: 1.5,
  },
})

const numberOfDots = 13
const logoBaseSize = 200
const radius = computed(() => (props.size / 100) * 44)
const dotRadius = computed(() => (props.size / 100) * 5.95)
const center = computed(() => props.size / 2)
const logoScale = computed(() => props.size / logoBaseSize)

const dots = computed(() => {
  return Array.from({ length: numberOfDots }, (_, i) => {
    const angle = -90 + (360 / numberOfDots) * i
    const x = center.value + radius.value * Math.cos((angle * Math.PI) / 180)
    const y = center.value + radius.value * Math.sin((angle * Math.PI) / 180)

    return {
      x,
      y,
      appearanceDelay: i * (props.animationSpeed / numberOfDots / 2),
    }
  })
})
</script>
<style scoped>
.dot {
  opacity: 0;
  animation: fill-and-fade linear infinite;
}

@keyframes fill-and-fade {
  0%,
  50% {
    opacity: 1;
  }
  51%,
  100% {
    opacity: 0;
  }
}
</style>
